export function getListIndentLevel(path) {
  let count = 1;
  path.forEach(node => {
    if (node.type.name === 'bulletList' || node.type.name === 'orderedList') {
      count++;
    }
  });
  return count;
}